import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=744ddf01&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"
import style0 from "./Version.vue?vue&type=style&index=0&id=744ddf01&prod&lang=scss&scoped=true"
import style1 from "./Version.vue?vue&type=style&index=1&id=744ddf01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ddf01",
  null
  
)

export default component.exports